import { v4 as uuid } from "uuid";

export let finalactivitydata = [{
    'GUID':uuid().toString(),
    "Activity": 'Request Created',
    "Description": 'Request for [Business_Unit] - [Contract_Type] is created by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been created by [Originator] on [Date]</p><p>Request for [Business_Unit] - [Contract_Type]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
 
  {
    'GUID':uuid().toString(),
    "Activity": 'Request Edited',
    "Description": 'Request for [Business_Unit] - [Contract_Type] is edited by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been edited by [Originator] on [Date]</p><p>Request for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
 
  {
    'GUID':uuid().toString(),
    "Activity": 'Business Approval',
    "Description": 'Business approval request received  for  [Business_Unit] - [Contract_Type] for [Assigned_To] from [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been received from [Originator] on [Date]</p><p>Business approval Request received for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
 
  {
    'GUID':uuid().toString(),
    "Activity": 'Request Approved',
    "Description": 'Business approval for  [Business_Unit] - [Contract_Type] approved by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been approved by [Originator] on [Date]</p><p>Business approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Request Rejected',
    "Description": 'Business approval  for  [Business_Unit] - [Contract_Type] rejected by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been rejected by [Originator] on [Date]</p><p>Business approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Contract Executed',
    "Description": 'Contract for [Business_Unit] - [Contract_Type] executed by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Contract No [contract_No] has been executed by [Originator] on [Date]</p><p>Contract for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
 
  {
    'GUID':uuid().toString(),
    "Activity": 'Upload Draft',
    "Description": 'A new draft uploaded by [Originator] for [Business_Unit] - [Contract_Type].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been uploaded by [Originator] on [Date]</p><p>draft uploaded for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
 
 
  {
    'GUID':uuid().toString(),
    "Activity": 'Negotiation',
    "Description": 'Draft presented to Contracting Party by [Originator] for the Request Number [[Request_Number]].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been presented to Contracting party by [Originator] on [Date]</p><p>Request for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
 
  {
    'GUID':uuid().toString(),
    "Activity": 'OnHold',
    "Description": 'Request Number [[Request_Number]] is on hold.',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] is on hold by [Originator] on [Date]</p><p>Request for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
 
  {
    'GUID':uuid().toString(),
    "Activity": 'Reply by Counterparty',
    "Description": 'Replied by Counterparty for the request number [[Request_Number]].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Counterparty replied to Request No [Request_Number] on [Date]</p><p>Request for [Business_Unit] - [Contract_Type]</p><p>[Remarks]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Reply by User',
    "Description": 'Replied by [User] for the request number [[Request_Number]].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>[User] replied to Request No [Request_Number] on [Date]</p><p>[Remarks]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Reply by User',
    "Description": 'Replied by [User] for the contract number [[Contract_Number]].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>[User] replied to Contract No [Contract_Number] on [Date]</p><p>[Remarks]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Withdraw Negotiation',
    "Description": 'Negotiation has been withdrawn by [Originator] for the Request Number [[Request_Number]].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Negotiation for the Request No [Request_Number] has been withdrawn by [Originator] on [Date]</p><p>Request for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><br/><p>CLM365 for Outlook</p>",
  },
 
  {
    'GUID':uuid().toString(),
    "Activity": 'Reject Draft By Party',
    "Description": 'Draft presented to Contracting Party Rejected  by Party for [Business_Unit] - [Contract_Type]',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been created by [Originator] on [Date]</p><p>Request for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Withdraw Request',
    "Description": 'Request has been withdraw for [Title] by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been withdraw by [Originator] on [Date]</p><p>Request for [Title]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
 
  {
    'GUID':uuid().toString(),
    "Activity": 'Accept Draft By Party',
    "Description": ' Draft presented to Contracting Party Accepted by Party for [Business_Unit] - [Contract_Type]',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been  Accepted by Party on [Date]</p><p>Draft presented to Contracting Party Accepted for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
 
  {
    'GUID':uuid().toString(),
    "Activity": 'Draft Approval',
    "Description": 'Draft Approval Request for [Business_Unit] - [Contract_Type] received for [Assigned_To] from [Originator]',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been created by [Originator] on [Date]</p><p>Request for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Draft Approved',
    "Description": 'Draft approval for  [Business_Unit] - [Contract_Type] approved by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been approved by [Originator] on [Date]</p><p>Draft approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Draft Rejected',
    "Description": 'Draft approval  for [Business_Unit] - [Contract_Type] has been rejected by [Originator]',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been rejected by [Originator] on [Date]</p><p>Draft approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Execution Approval',
    "Description": 'Execution approval for  [Business_Unit] - [Contract_Type] received for [Assigned_To] from [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been created by [Originator] on [Date]</p><p>Execution Approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
 
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Request Submitted',
    "Description": 'Request for [Business_Unit] - [Contract_Type] is submitted by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been submitted by [Originator] on [Date]</p><p>Request for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Legal Review',
    "Description": 'Legal Review Request for [Business_Unit] - [Contract_Type] received for [Assigned_To] from [Originator]',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been created by [Originator] on [Date]</p><p>Legal Review for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Legal Assignment',
    "Description": 'Legal Assignment Request for [Business_Unit] - [Contract_Type] received for [Assigned_To] from [Originator]',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been created by [Originator] on [Date]</p><p>Legal Assignment for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
 
  {
    'GUID':uuid().toString(),
    "Activity": 'Business Approved',
    "Description": 'Business approval for  [Business_Unit] - [Contract_Type] approved by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been approved by [Originator] on [Date]</p><p>Business approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Additional Task Approved',
    "Description": 'Additional Task for  [Business_Unit] - [Contract_Type] approved by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been approved by [Originator] on [Date]</p><p>Additional Task for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Execution Approved',
    "Description": 'Execution approval for  [Business_Unit] - [Contract_Type] approved by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been approved by [Originator] on [Date]</p><p>Execution approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Publish',
    "Description": 'Publish approval request received  for  [Business_Unit] - [Contract_Type] for [Assigned_To] from [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been received from [Originator] on [Date]</p><p>Publish approval Request received for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Publish Approved',
    "Description": 'Publish approval for  [Business_Unit] - [Contract_Type] approved by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been approved by [Originator] on [Date]</p><p>Publish approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><br/><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Additional Task',
    "Description": 'Additional Task Request for [Business_Unit] - [Contract_Type] received for [Assigned_To] from [Originator]',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been created by [Originator]</p><br/><p>The request was created on [Date]</p><br/><p>Additional Task for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><br/><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Deviation Task',
    "Description": 'Deviation Task Request for [Business_Unit] - [Contract_Type] received for [Assigned_To] from [Originator]',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been created by [Originator]</p><br/><p>The request was created on [Date]</p><br/><p>Deviation Task for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><br/><p>Contract Lifecycle Management</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Deviation Task Approved',
    "Description": 'Deviation Task for  [Business_Unit] - [Contract_Type] approved by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been approved by [Originator] on [Date]</p><p>Legal Review for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><br/><p>Contract Lifecycle Management</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Deviation Task Rejected',
    "Description": 'Deviation Task for  [Business_Unit] - [Contract_Type] rejected by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been rejected by [Originator] on [Date]</p><p>Legal Review for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><br/><p>Contract Lifecycle Management</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Legal Review Approved',
    "Description": 'Legal Review for  [Business_Unit] - [Contract_Type] approved by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been approved by [Originator] on [Date]</p><p>Legal Review for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><br/><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Legal Assignment Approved',
    "Description": 'Legal Assignment for  [Business_Unit] - [Contract_Type] approved by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been approved by [Originator] on [Date]</p><p>Legal Assignment for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><br/><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Business User',
    "Description": 'Business approval for  [Business_Unit] - [Contract_Type] send back to Business User by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been send by [Originator]</p><br/><p>The request was send back to Business User on [Date]</p><br/><p>Business approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><br/><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Contract Approval',
    "Description": 'Contract Approval Request for [Business_Unit] - [Contract_Type] received for [Assigned_To] from [Originator]',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Contract No [Contract_Number] has been created by [Originator]</p><br/><p>The request was created on [Date]</p><br/><p>Request for [Business_Unit] - [Contract_Type]</p><br/><p>[Contract_URL]</p><br/><p>Best regards,</p><br/><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Contract Approved',
    "Description": 'Contract Approval for  [Business_Unit] - [Contract_Type] approved by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Contract No [Contract_Number] has been approved by [Originator]</p><p>Contract approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Contract_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Termination',
    "Description": 'Contract Termination Request for [Business_Unit] - [Contract_Type] received for [Assigned_To] from [Originator]',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Contract No [Contract_Number] has been created by [Originator] on [Date]</p><p>Contract Termination Request for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Contract_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Terminated',
    "Description": 'Contract Termination for  [Business_Unit] - [Contract_Type] approved by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Contract No [Contract_Number] has been approved by [Originator] on [Date]</p><p>Contract Termination for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Contract_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Termination Rejected',
    "Description": 'Contract Termination approval  for  [Business_Unit] - [Contract_Type] rejected by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Contract No [Contract_Number] has been rejected by [Originator] on [Date]</p><p>Contract Termination approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Contract_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Business Rejected',
    "Description": 'Business approval  for  [Business_Unit] - [Contract_Type] rejected by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been rejected by [Originator] on [Date]</p><p>Business approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Additional Task Rejected',
    "Description": 'Additional Task approval  for  [Business_Unit] - [Contract_Type] rejected by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been rejected by [Originator]</p><p>Additional Task approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Legal Review Rejected',
    "Description": 'Legal Review approval  for  [Business_Unit] - [Contract_Type] rejected by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been rejected by [Originator] on [Date]</p><p>Legal Review approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Legal Assignment Rejected',
    "Description": 'Legal Assignment approval  for  [Business_Unit] - [Contract_Type] rejected by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been rejected by [Originator] on [Date]</p><p>Legal Assignment approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Execution Rejected',
    "Description": 'Execution approval  for  [Business_Unit] - [Contract_Type] rejected by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been rejected by [Originator] on [Date]</p><p>Execution approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Publish Rejected',
    "Description": 'Publish approval  for  [Business_Unit] - [Contract_Type] rejected by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been rejected by [Originator] on [Date]</p><p>Publish approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Contract Rejected',
    "Description": 'Contract approval  for  [Business_Unit] - [Contract_Type] rejected by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Contract No [Contract_Number] has been rejected by [Originator] on [Date]</p><p>Contract approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Contract_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Contract Added',
    "Description": 'Contract for [Business_Unit] - [Contract_Type] is added by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Contract No [Contract_Number] has been added by [Originator] on [Date]</p><p>Contract for [Business_Unit] - [Contract_Type]</p><p>[Contract_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Contract Submitted',
    "Description": 'Contract for [Business_Unit] - [Contract_Type] is submitted by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Contract No [Contract_Number] has been submitted by [Originator] on [Date]</p><p>Contract for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Contract_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Contract Edited',
    "Description": 'Contract for [Business_Unit] - [Contract_Type] is edited by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Contract No [Contract_Number] has been edited by [Originator] on [Date]</p><p>Contract for [Business_Unit] - [Contract_Type]</p><p>[Contract_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
 
  {
    'GUID':uuid().toString(),
    "Activity": 'eSign',
    "Description": 'eSign task for [Business_Unit] - [Contract_Type] received for [Assigned_To] from [Originator]',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been created by [Originator] on [Date]</p><p>eSign for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'eSign Completed',
    "Description": 'eSign task for  [Business_Unit] - [Contract_Type] Completed by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been Completed by [Originator] on [Date]</p><p>eSign for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'eSign Rejected',
    "Description": 'eSign task  for [Business_Unit] - [Contract_Type] has been rejected by [Originator]',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been rejected by [Originator] on [Date]</p><p>eSign for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Legal Review Completed',
    "Description": 'Legal Review Completed for [Business_Unit] - [Contract_Type]',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been submitted by [Originator] on [Date]</p><p>Legal Review Completed</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Negotiation Completed',
    "Description": 'Negotiation for  [Business_Unit] - [Contract_Type] Completed by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been Completed by [Originator] on [Date]</p><p>Negotiation for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Obligation Rejected',
    "Description": 'Obligation task  for [Business_Unit] - [Contract_Type] has been rejected by [Originator]',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been rejected by [Originator] on [Date]</p><p>Obligation task for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Business Approval Hold',
    "Description": 'Business approval for  [Business_Unit] - [Contract_Type] hold by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been hold by [Originator] on [Date]</p><p>Business approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Legal Review Hold',
    "Description": 'Legal Review for  [Business_Unit] - [Contract_Type] hold by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been hold by [Originator] on [Date]</p><p>Legal Review approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Draft Approval Hold',
    "Description": 'Draft approval for  [Business_Unit] - [Contract_Type] hold by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been hold by [Originator] on [Date]</p><p>Draft approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Execution Approval Hold',
    "Description": 'Execution Approval for  [Business_Unit] - [Contract_Type] hold by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been hold by [Originator] on [Date]</p><p>Execution approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Contract Approval Hold',
    "Description": 'Contract Approval for  [Business_Unit] - [Contract_Type] hold by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been hold by [Originator] on [Date]</p><p>Contract approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Contract_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Termination Hold',
    "Description": 'Contract Termination approval for  [Business_Unit] - [Contract_Type] hold by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been hold by [Originator] on [Date]</p><p>Contract Termination approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Contract_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Additional Task Hold',
    "Description": 'Additional Task approval for  [Business_Unit] - [Contract_Type] hold by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Request No [Request_Number] has been hold by [Originator] on [Date]</p><p>Additional Task approval for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Obligation Completed',
    "Description": '[Obligation_Task] Obligation for  [Business_Unit] - [Contract_Type] Approved by [Originator].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Contract No [Contract_Number] has been Completed by [Originator] on [Date]</p><p>Obligation for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Draft Edited',
    "Description": 'Draft updated for [Business_Unit] - [Contract_Type] is edited by [Originator].',
    "EmailTemplate":
    "<p>Hi,</p><br/><p>Draft updated by [Originator] on [Date]</p><p>Request for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><p>[Request_URL]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Send Message',
    "Description": '[sendUser] messaged [receivedUser]',
    "EmailTemplate":
    "<p>Hi,</p><br/><p>[message]</p><br/><p>Best regards,</p><p>CLM365 for Outlook</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Send Note',
    "Description": '[sendUser] added a note for [Business_Unit] - [Contract_Type]',
    "EmailTemplate":
    "<p>Hi,</p><br/><p>[noteFieldValue]</p><br/><p>Best regards,</p><p>Contract Lifecycle Management</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Add Attachments',
    "Description": '[sendUser] uploaded attachment for [Business_Unit] - [Contract_Type]',
    "EmailTemplate":
    "<p>Hi,</p><br/><p>Request No [Request_Number] has been uploaded by [Originator] on [Date]</p><p>attachments uploaded for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><p>Contract Lifecycle Management</p>",
  },
  {
    'GUID':uuid().toString(),
    "Activity": 'Negotiation Rejected',
    "Description": 'Negotiation has been Rejected by [Originator] for the Request Number [[Request_Number]].',
    "EmailTemplate":
      "<p>Hi,</p><br/><p>Negotiation for the Request No [Request_Number] has been Rejected by [Originator] on [Date]</p><p>Request for [Business_Unit] - [Contract_Type]</p><br/><p>[Remarks]</p><br/><p>Best regards,</p><br/><p>CLM365 for Outlook</p>",
  },
  ]